import { j as e } from "./jsx-runtime-3tyXYecC.mjs";
import r, { useEffect as h } from "react";
import { c as p, C as L } from "./card-vPwejA0-.mjs";
import { createPortal as b } from "react-dom";
import { f as m } from "./index-LyFokDcn.mjs";
import { m as x } from "./tss-DN0acMKN.mjs";
import { C as u } from "./content-iXOVBfdp.mjs";
import { S as _ } from "./svg-BXFXFNTY.mjs";
import { d as g } from "./index-DH8DM7A9.mjs";
const d = (t) => r.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 113 17", width: "113", height: "17" }, t),
  r.createElement(
    r.Fragment,
    null,
    r.createElement(
      "g",
      { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
      r.createElement(
        "g",
        null,
        r.createElement("path", { d: "M28.2954636,15.3126531 C25.6819679,15.3126531 24.4195306,13.2078222 24.4195306,11.1705277 C24.4195306,9.13323324 25.6819679,7.05146356 28.3402682,7.05146356 C30.4220379,7.05146356 32.1275802,8.71220117 32.1275802,11.2370758 C32.1275802,13.6288542 30.2892711,15.3126531 28.2954636,15.3126531 Z M31.9727405,7.40495918 L31.9500087,7.40495918 C31.2189679,6.54148105 30.0902857,5.52349271 28.1636851,5.52349271 C24.9957318,5.52349271 22.6042828,7.89155102 22.6042828,11.1705277 C22.6042828,14.625758 25.1742915,16.8626968 28.0520029,16.8626968 C29.8464956,16.8626968 31.1534082,15.9992187 31.9282653,15.068863 L31.9727405,15.068863 L31.9727405,16.4864694 L33.7220991,16.4864694 L33.7220991,5.87731778 L31.9727405,5.87731778 L31.9727405,7.40495918 Z" }),
        r.createElement("path", { d: "M47.3921341,5.52349271 C45.5541545,5.52349271 44.2693149,6.65184548 43.7375889,7.71562682 C43.2941545,6.47493294 41.9434257,5.52349271 40.2823586,5.52349271 C38.9092274,5.52349271 37.8240321,6.25420408 37.1163819,7.20597376 L37.0715773,7.20597376 L37.0715773,5.87731778 L35.3205714,5.87731778 L35.3205714,16.4864694 L37.0715773,16.4864694 L37.0715773,10.5949854 C37.0715773,8.37979009 38.2005889,7.09527988 39.9726793,7.09527988 C41.5451254,7.09527988 42.4972245,8.42393586 42.4972245,10.172965 L42.4972245,16.4864694 L44.2693149,16.4864694 L44.2693149,10.5949854 C44.2693149,8.15840233 45.664519,7.09527988 47.1486735,7.09527988 C48.9428367,7.09527988 49.6949621,8.53462974 49.6949621,10.172965 L49.6949621,16.4864694 L51.445309,16.4864694 L51.445309,10.307379 C51.445309,7.18423032 49.784242,5.52349271 47.3921341,5.52349271" }),
        r.createElement("path", { d: "M70.8684606,15.2681778 C68.8305073,15.2681778 67.01493,13.5619767 67.01493,11.1705277 C67.01493,8.82289504 68.6097784,7.09527988 70.8684606,7.09527988 C73.193691,7.09527988 74.7219913,8.93325948 74.7219913,11.1705277 C74.7219913,13.495758 73.1044111,15.2681778 70.8684606,15.2681778 Z M70.8684606,5.52349271 C67.6787638,5.52349271 65.1983644,7.89155102 65.1983644,11.1705277 C65.1983644,14.3816385 67.6563615,16.8626968 70.8684606,16.8626968 C74.1461195,16.8626968 76.537898,14.2936764 76.537898,11.1705277 C76.537898,7.95941691 74.1672041,5.52349271 70.8684606,5.52349271 Z" }),
        r.createElement("path", { d: "M83.326793,15.2681778 C81.2908163,15.2681778 79.4745802,13.5619767 79.4745802,11.1705277 C79.4745802,8.82289504 81.0690991,7.09527988 83.326793,7.09527988 C85.6536706,7.09527988 87.1816414,8.93325948 87.1816414,11.1705277 C87.1816414,13.495758 85.5640612,15.2681778 83.326793,15.2681778 Z M83.326793,5.52349271 C80.138414,5.52349271 77.6580146,7.89155102 77.6580146,11.1705277 C77.6580146,14.3816385 80.1173294,16.8626968 83.326793,16.8626968 C86.6044519,16.8626968 88.9975481,14.2936764 88.9975481,11.1705277 C88.9975481,7.95941691 86.6285015,5.52349271 83.326793,5.52349271 Z" }),
        r.createElement("path", { d: "M97.3026 10.4253 91.6789 10.4253 91.6789 5.9139 90.3931 5.9139 90.3931 16.4865 91.6789 16.4865 91.6789 11.6034 97.3026 11.6034 97.3026 16.4865 98.5887 16.4865 98.5887 5.9139 97.3026 5.9139 97.3026 10.4253" }),
        r.createElement("path", { d: "M101.843968,10.8898397 L101.843968,7.09198542 L103.750472,7.09198542 C105.116026,7.09198542 105.859915,7.77459767 105.859915,9.01397376 C105.859915,10.0378921 105.162149,10.8898397 103.765297,10.8898397 L101.843968,10.8898397 Z M104.744082,11.9443965 C106.076032,11.6805102 107.192525,10.5182245 107.192525,9.01397376 C107.192525,7.55716327 106.246356,5.9138863 103.611446,5.9138863 L100.557152,5.9138863 L100.557152,16.4864694 L101.843968,16.4864694 L101.843968,12.0685977 L103.255644,12.0685977 L106.447977,16.4864694 L108.076429,16.4864694 L104.744082,11.9443965 Z" }),
        r.createElement("path", { d: "M108.424 5.9172 110.0969 5.9172 110.0969 6.1765 109.413 6.1765 109.413 8.2599 109.1112 8.2599 109.1112 6.1765 108.424 6.1765 108.424 5.9172" }),
        r.createElement("path", { d: "M111.6058 7.569 112.318 5.9172 112.7048 5.9172 112.8083 8.2599 112.5009 8.2599 112.4301 6.3692 111.7333 7.9126 111.4625 7.9126 110.768 6.3692 110.6978 8.2599 110.3891 8.2599 110.4946 5.9172 110.8876 5.9172 111.6058 7.569" }),
        r.createElement("path", { d: "M58.3791603,15.4141224 C56.1675889,15.4141224 54.2956764,13.6703644 54.2956764,11.3342624 C54.2956764,8.99750146 55.873723,7.07814869 58.4190233,7.07814869 C60.9636647,7.07814869 62.4633032,9.13553936 62.4633032,11.291105 C62.4633032,13.6364315 60.8770204,15.4141224 58.3791603,15.4141224 Z M58.5560729,5.4075277 C56.5181195,5.4075277 55.4256764,6.10694169 54.6593848,6.86763265 L54.450516,7.08704373 L54.4498571,1.30823032 L52.6889679,1.30823032 L52.6889679,11.4354023 C52.6889679,14.8751487 55.3387026,17.0185248 58.3791603,17.0185248 C61.728309,17.0185248 64.2640554,14.4409388 64.2640554,11.1276997 C64.2640554,8.05133236 61.6189329,5.4075277 58.5560729,5.4075277 Z" }),
        r.createElement("path", { d: "M15.459586,15.4141224 C13.2480146,15.4141224 11.3764315,13.6703644 11.3764315,11.3342624 C11.3764315,8.99750146 12.9544781,7.07814869 15.4991195,7.07814869 C18.0444198,7.07814869 19.5440583,9.13553936 19.5440583,11.291105 C19.5440583,13.6364315 17.9571166,15.4141224 15.459586,15.4141224 Z M15.6364985,5.4075277 C13.5988746,5.4075277 12.506102,6.10694169 11.7398105,6.86763265 L11.5309417,7.08704373 L11.5302828,0.255979592 L9.76972303,0.255979592 L9.76972303,11.4354023 C9.76972303,14.8751487 12.4191283,17.0185248 15.459586,17.0185248 C18.8087347,17.0185248 21.344481,14.4409388 21.344481,11.1276997 C21.344481,8.05133236 18.699688,5.4075277 15.6364985,5.4075277 Z" }),
        r.createElement("path", { d: "M8.9391895,7.67609329 C8.9391895,7.67609329 8.16861516,7.53146647 7.53706706,7.43625656 C6.80470845,7.32523324 6.48053353,7.21651603 5.5491895,6.83666472 C4.61784548,6.4574723 3.7754519,5.5284344 2.94920117,4.49331487 C2.12360933,3.45753644 0.195690962,1.83040233 0.195690962,1.83040233 C0.195690962,1.83040233 0.791988338,1.86927697 1.39652187,2.02016327 C1.89134985,2.14370554 3.18080175,2.56177259 4.51110496,3.25262099 C4.80595918,3.40548397 4.96936443,3.50530612 5.26026531,3.68518367 C5.70271137,3.95829446 6.16788921,4.36614869 6.61330029,4.8174898 C7.13646064,5.34822741 7.59472012,5.77486006 7.98610204,6.24959184 C7.56012828,5.46518076 6.45582507,2.64149854 4.29696501,0.310997085 C4.08546064,0.0826909621 5.78902624,1.13032945 6.23904956,1.60604956 C7.55320991,2.99367638 7.69124781,3.76853353 8.15774344,5.11563848 L8.9391895,7.67609329" })
      )
    )
  )
);
d.displayName = "BamboohrLogo113x18";
const j = window.jQuery ? $.__("Privacy Policy") : "Privacy Policy", v = window.jQuery ? $.__("Terms of Service") : "Terms of Service";
function w() {
  const t = new g.BEM("fab-InterstitialPrivacyAndTerms"), a = `${t.elem("link")} fab-Link fab-Link--muted`;
  return /* @__PURE__ */ e.jsxs("div", { className: t.elem(), children: [
    /* @__PURE__ */ e.jsx(
      "a",
      {
        className: a,
        href: "https://www.bamboohr.com/privacy.php",
        rel: "noopener external nofollow noreferrer",
        target: "_blank",
        children: j
      }
    ),
    /* @__PURE__ */ e.jsx("span", { className: t.elem("dot"), children: "·" }),
    /* @__PURE__ */ e.jsx(
      "a",
      {
        className: a,
        href: "https://www.bamboohr.com/terms.php",
        rel: "noopener external nofollow noreferrer",
        target: "_blank",
        children: v
      }
    )
  ] });
}
function E(t) {
  const { renderFooterEtc: a = () => /* @__PURE__ */ e.jsx(w, {}) } = t;
  return /* @__PURE__ */ e.jsxs("div", { className: "fab-InterstitialFooter", children: [
    /* @__PURE__ */ e.jsx("div", { className: "fab-InterstitialFooter__extra", children: a() }),
    /* @__PURE__ */ e.jsx(
      "a",
      {
        className: "fab-InterstitialFooter__logo",
        href: "https://www.bamboohr.com",
        rel: "noopener external nofollow noreferrer",
        target: "_blank",
        children: m.ifFeature(
          "encore",
          /* @__PURE__ */ e.jsx(_, { color: "neutral-strong", height: 17, image: "bamboohr-logo", width: 115 }),
          /* @__PURE__ */ e.jsx(d, { title: "BambooHR Logo" })
        )
      }
    )
  ] });
}
function I(t = "") {
  return (t[0] || "").toUpperCase() + t.substr(1);
}
const M = x()((t, a) => {
  const {
    constructs: n,
    mixins: { boxShadow: o },
    spacing: s
  } = t, { cardSize: i } = a;
  return {
    card: {
      backgroundColor: n.surface.neutral.inverted,
      borderRadius: s(2),
      boxShadow: o("500", n.surface.neutral.xxStrong),
      boxSizing: "border-box",
      display: "inline-grid",
      gap: s(2),
      padding: s(2.5),
      width: p[i]
    }
  };
}), c = document.createElement("div"), N = ({
  cardSize: t,
  centerByCard: a,
  children: n,
  overlay: o = "everything",
  renderOuterContent: s,
  renderCard: i,
  renderFooterEtc: C
}) => {
  const { classes: f } = M({ cardSize: t });
  h(() => {
    o === "everything" && document.body.appendChild(c);
  }, [o]), i = i || m.ifFeature(
    "encore",
    () => /* @__PURE__ */ e.jsx("div", { className: f.card, children: n }),
    () => /* @__PURE__ */ e.jsx(L, { size: t, children: /* @__PURE__ */ e.jsx(u, { children: n }) })
  );
  const l = /* @__PURE__ */ e.jsxs("div", { className: `fab-Interstitial fab-Interstitial--overlay${I(o)}`, "data-fabric-component": "Interstitial", children: [
    /* @__PURE__ */ e.jsx("div", { className: "fab-Interstitial__outer", children: /* @__PURE__ */ e.jsxs("div", { className: "fab-Interstitial__inner", children: [
      /* @__PURE__ */ e.jsx("div", { className: "fab-Interstitial__card", children: i() }),
      /* @__PURE__ */ e.jsxs("div", { className: a ? "fab-Interstitial__outerContentWrapper--absolute" : "", children: [
        s && s(),
        /* @__PURE__ */ e.jsx("div", { className: "fab-Interstitial__footer", children: /* @__PURE__ */ e.jsx(E, { renderFooterEtc: C }) })
      ] })
    ] }) }),
    /* @__PURE__ */ e.jsx("div", { className: "fab-Interstitial__overlay" })
  ] });
  return o === "everything" ? b(l, c) : l;
};
N.displayName = "Interstitial";
function z(t) {
  const { children: a, path: n = "/", text: o = window.jQuery ? $.__("Login to BambooHR") : "Login to BambooHR" } = t;
  return /* @__PURE__ */ e.jsx("a", { className: "fab-InterstitialGoToAppLink fab-Link fab-Link--muted", href: n, rel: "noopener external nofollow noreferrer", children: a || o });
}
export {
  z as G,
  N as I
};
//# sourceMappingURL=go-to-app-link-DS9SRf6u.mjs.map
